import { type PaymentMethodType } from './business';

export const TERMINAL_PAYMENT_STATUS = {
    PROCESSED: 'PROCESSED',
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    SUCCESSFUL: 'SUCCESSFUL',
    PROCESSING: 'PROCESSING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED',
    TIMED_OUT: 'TIMED_OUT',
} as const;

export type TerminalPaymentStatus =
    (typeof TERMINAL_PAYMENT_STATUS)[keyof typeof TERMINAL_PAYMENT_STATUS];

export interface TerminalPayment {
    merchantReference: string;
    paymentType: PaymentMethodType;
    message: string | null;
    amount: string;
    status: TerminalPaymentStatus;
}

export interface TerminalApiPaymentRequest {
    merchantReference: string;
    terminalSerial: string;
    amount: number;
    orderNumber?: string;
}

export const CREATE_TERMINAL_RESPONSE_STATUS = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
} as const;

export type CreateTerminalResponseStatus =
    (typeof CREATE_TERMINAL_RESPONSE_STATUS)[keyof typeof CREATE_TERMINAL_RESPONSE_STATUS];

export interface CreateTerminalPaymentResponse {
    amount: number;
    merchantReference: string;
    message: string;
    status: CreateTerminalResponseStatus;
    terminalSerial: string;
}

export interface TerminalPaymentStatusResponse {
    merchantReference: string;
    paymentType: PaymentMethodType;
    message: string | null;
    requestAmount: number;
    processedAmount: number;
    status: TerminalPaymentStatus;
    paymentDetails: Record<string, string>;
    paymentMethodType: PaymentMethodType;
}

export const TERMINAL_TYPE = {
    USB: 'USB',
    API: 'API',
} as const;

export type TerminalType = (typeof TERMINAL_TYPE)[keyof typeof TERMINAL_TYPE];

export const MONIEPOINT_TERMINAL_USB_ID = 'moniepoint-terminal:usb';

export const MAX_CONNECTED_TERMINALS = 5;

export interface CardTransactionRecord {
    pan: string;
    ref: string;
    rrn: string;
    card: string;
    stan: string;
    amount: number;
    client: string;
    message: string;
    business: string;
    reversed: boolean;
    transactedAt?: string;
}
